<template>
  <div>
    <v-card elevation="1" tile>
      <v-card class="mx-auto d-flex" width="100%" elevation="0" tile>
        <v-container fluid class="py-0">
          <v-row>
            <v-col cols="12" md="8" lg="8" sm="12" class="py-1">
              <v-breadcrumbs class="py-2 pb-0 pl-0 px-md-2 py-md-3">
                <v-breadcrumbs-item>
                  <RouterLink to="/" class="text-decoration-none">
                    <span>
                      <v-icon size="20">mdi-home</v-icon>
                      <v-icon v-if="activeBreadCrumbs" right>mdi-menu-right-outline</v-icon>
                    </span>
                  </RouterLink>
                </v-breadcrumbs-item>

                <v-breadcrumbs-item v-for="(item, key) in activeBreadCrumbs" v-bind:key="key">
                  <RouterLink
                    :to="item.link"
                    class="text-decoration-none"
                    v-if="key != (activeBreadCrumbs.length-1)"
                  >
                    <span>
                      {{item.text}}
                      <v-icon right>mdi-menu-right-outline</v-icon>
                    </span>
                  </RouterLink>
                  <span v-else class="grey--text">{{item.text}}</span>
                </v-breadcrumbs-item>
              </v-breadcrumbs>
            </v-col>
            <v-col cols="12" md="4" lg="4" sm="12" class="d-flex align-center py-1 mb-1 mb-md-0">
              <div id="searchArea">
                <v-text-field
                  single-line
                  solo-inverted
                  dense
                  :label="$t('PANEL.HEADER.SEARCHBOX_LABEL')"
                  hide-details="auto"
                  v-model="search"
                  @focus="searchFocus = true"
                  @blur="onBlur"
                  @input="searchInNavs"
                >
                  <template v-slot:prepend-inner>
                    <v-icon :dark="searchFocus">mdi-magnify</v-icon>
                  </template>
                  <template v-slot:append>
                    <v-icon v-show="search.length >= 3" :dark="searchFocus" @click="search = ''">mdi-close</v-icon>
                  </template>
                </v-text-field>
                <v-card id="searchItems" class="px-3 py-2" v-show="listExist() && search.length >= 3 && searchFocus">
                  <div
                    v-show="item.list.length > 0"
                    :key="key"
                    v-for="(item, key) in searchList"
                    class="mb-3"
                  >
                    <p class="text-subtitle-1 grey--text text--darken-3 mb-0">
                      <strong>{{item.name}}</strong>
                    </p>
                    <v-divider></v-divider>
                    <v-list>
                      <v-list-item
                        :key="key"
                        v-for="(nav, key) in item.list"
                        :to="`${item.link}/${nav.link}`"
                        @click="search = ''"
                        class="search-list-item text-decoration-none text-subtitle-2 px-2"
                        dense
                      >
                        <v-icon v-text="nav.icon" size="20" left></v-icon>
                        {{nav.name}}
                      </v-list-item>
                    </v-list>
                  </div>
                </v-card>
                <v-card id="searchItems" class="grey lighten-5 px-3 pt-5" v-show="!listExist() && search.length >= 3 && searchFocus">
                  <p class="text-subtitle-2 d-flex align-center justify-center">
                    <v-icon size="20" color="red darken-4" left>mdi-emoticon-neutral-outline</v-icon>
                    Aradığınız kritere ait sonuç bulunamadı</p>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "BreadCrumbs",
  props: ["items"],
  data: () => ({
    search: "",
    searchFocus: false,
    searchList: []
  }),
  computed: {
    ...mapState({
      systemTree: state => state.systemTree,
      activeBreadCrumbs: state => state.activeBreadCrumbs
    }),
  },
  created() {
    /**
     * Store'u dinle ve değişiklik varsa breadcrumb'ı ekle
     */
    // store.watch(state => state.breadCrumbs, (newValue) => {
    //     this.activeBreadCrumbs = newValue
    // })
  },
  mounted() {
    // let searchArea = document.getElementById("searchArea")
    // document.body.onclick = (e) => {
    //   console.log(e.target.parentNode.querySelector("#searchArea"));
    //   // console.log(e.target.querySelector("#searchArea"));
    // }
  },
  methods: {
    onBlur() {
      setTimeout(() => {
        this.searchFocus = false
      }, 150);
    },
    searchInNavs(search) {
      if (search.length >= 3) {
        let parents = [];
        for (let i in this.systemTree) {
          parents.push(this.systemTree[i]);
        }

        let filterItems = (needle, heystack) => {
          let query = needle.toLowerCase();
          return heystack.filter(item => {
            return (
              item.name.toLowerCase().indexOf(query) >= 0 ||
              item.link.toLowerCase().indexOf(query) >= 0
            );
          });
        };

        let navigations = {};
        parents = JSON.parse(JSON.stringify(parents));
        parents.forEach((nav, key) => {
          navigations[key] = nav;
          navigations[key].list = filterItems(
            search,
            this.searchInNested(nav.child)
          );
        });
        this.searchList = navigations;
      }
    },
    searchInNested(node, link = "") {
      let parsed = [];
      Object.keys(node).forEach(key => {
        if (node[key].icon !== "") {
          node[key].link = Object.assign(link + node[key].link + "/", {});
          parsed.push(node[key]);
        }
        if (Object.keys(node[key].child).length > 0) {
          parsed = parsed.concat(
            this.searchInNested(node[key].child, node[key].link)
          );
        }
      });

      return parsed;
    },
    listExist() {
      let list = false;
      if (this.searchList.constructor === Object) {
        for (let n in this.searchList) {
          if (this.searchList[n].list.length > 0) {
            list = true;
          }
        }
      }
      return list;
    },
    parseBreadCrumbs() {
      var navs = [],
        tree = this.systemTree,
        paths =
          this.$route.fullPath === "/"
            ? ["/"]
            : this.$route.fullPath
                .split("/")
                .filter(path => path !== "")
                .map((path, key) => (key === 0 ? (path = "/" + path) : path)),
        pathTree = ""; // Her döngüde linkleri arka arkaya al

      paths.forEach(path => {
        let nav = tree
          ? Object.values(tree).find(node => node.link === path)
          : "";
        if (!nav) return;
        tree = Object.keys(nav).length > 0 ? nav.child : "";
        pathTree += "/" + nav.link.replace("/", "");
        navs.push({
          text: nav.name,
          link: pathTree
        });
      });

      if (paths.length !== navs.length)
        navs.push({
          text: this.$router.history.current.name
        });

      return navs;
    }
  },
  watch: {
    $route: {
      handler() {
        this.$store.commit("setActiveBreadcrumbs", this.parseBreadCrumbs());
      },
      immediate: true
    }
  },
};
</script>

<style>
.panel-breadcrumbs {
  background-color: #fff;
}
#searchArea {
  position: relative;
  flex-basis: 100%;
}
#searchItems {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 5;
}
</style>